export * from './current-mobile-resource.module';
export * from './current-mobile-resource.service';
